import * as React from 'react';
import { EventHandler, FocusEvent } from 'react';
import { FieldError } from 'react-hook-form';

import FormControlWrapper from './FormControlWrapper';

interface Props {
  name: string;
  autoComplete?: string;
  placeholder: string;
  ref: React.LegacyRef<HTMLInputElement>;
  error: FieldError;
  disabled?: boolean;
  className?: string;
  onChange?: (event: React.ChangeEvent<Element>) => void;
  onBlur?: EventHandler<FocusEvent<any>>;
  defaultValue?: string;
}

const FormInput = (
  { disabled = false, name, autoComplete, placeholder, error, className = '', onChange, onBlur, defaultValue }: Props,
  ref
) => (
  <FormControlWrapper error={error} label={placeholder} className={className}>
    {(_, errorClassName) => (
      <input
        className={errorClassName}
        name={name}
        disabled={disabled}
        ref={ref}
        placeholder={placeholder}
        onBlur={onBlur}
        {...(autoComplete ? { autoComplete } : {})}
        {...(onChange ? { onChange } : {})}
        {...(defaultValue ? { defaultValue } : {})}
      />
    )}
  </FormControlWrapper>
);

export default React.forwardRef(FormInput);
